import React from 'react';
import { IntlProvider } from 'react-intl';
import { CookiesProvider } from 'react-cookie';
import { Provider, useSelector } from 'react-redux';
import { store } from '../../../../store/store';
import { getLocale } from '../../selectors';
import { localeService } from '../../helpers';
export const defaultRichTextElements = {
    b: (chunks) => <b>{chunks}</b>,
    br: () => <br />,
    em: (chunks) => <em>{chunks}</em>,
    h1: (chunks) => <h1>{chunks}</h1>,
    h2: (chunks) => <h2>{chunks}</h2>,
    h3: (chunks) => <h3>{chunks}</h3>,
    h4: (chunks) => <h4>{chunks}</h4>,
    h5: (chunks) => <h5>{chunks}</h5>,
    h6: (chunks) => <h6>{chunks}</h6>,
    i: (chunks) => <i>{chunks}</i>,
    li: (chunks) => <li>{chunks}</li>,
    ol: (chunks) => <ol>{chunks}</ol>,
    p: (chunks) => <p>{chunks}</p>,
    span: (chunks) => <span>{chunks}</span>,
    strong: (chunks) => <strong>{chunks}</strong>,
    ul: (chunks) => <ul>{chunks}</ul>,
    sup: (chunks) => <sup>{chunks}</sup>,
};
const withTranslationProvider = (WrappedComponent) => {
    const TranslationProvider = (props) => {
        const locale = useSelector(getLocale);
        return (<IntlProvider defaultRichTextElements={defaultRichTextElements} defaultLocale='en' messages={localeService.instance.messages} locale={locale || 'en'}>
        <WrappedComponent {...props}/>
      </IntlProvider>);
    };
    return TranslationProvider;
};
export const withProviders = (WrappedComponent) => {
    const TranslationProvider = withTranslationProvider(WrappedComponent);
    const Providers = (props) => (<Provider store={store}>
        <CookiesProvider>
          <TranslationProvider {...props}/>
        </CookiesProvider>
    </Provider>);
    return Providers;
};
export default withProviders;
